<template>
  <section>
    <div v-if="currentShow" class="current-show">
      <div class="current-show__inner">
        <div class="current-show__inner__image">
          <picture>
            <img :src="currentShow.image_path ? currentShow.image_path : mrLogo" />
          </picture>
        </div>
        <div class="current-show__inner__info">
          <div class="current-show__inner__info__time">
            live now on STEGI.RADIO {{ liveChannel.id }} / {{ formatDateToTime(currentShow.starts) }} -
            {{ formatDateToTime(currentShow.ends) }}
          </div>
          <div class="current-show__inner__info__title">
            {{ removeWeirdCharacters(currentShow.name) }}
          </div>
          <p v-if="currentShow.description"
             class="current-show__inner__info__description"
             v-html="currentShow.description"
          />
          <div class="current-show__inner__info__utilities">
            <router-link
              v-if="currentShow.url"
              class="icon-link"
              :to="{ path: formatUrl(currentShow.url) }"
            >
              <span>EXPLORE SHOW</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import mrLogo from '@/assets/logos/stegi-radio-logo-black.svg';
export default {
  name: 'ScheduleCurrentShow',
  props: {
    liveChannel: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    currentShow: null,
    mrLogo: mrLogo,
    loading: false
  }),
  mounted() {
    this.getPlayingNow();
  },
  methods: {
    formatDateToTime(date) {
      return moment(date).format('HH:mm');
    },
    formatUrl(url) {
      const path = new URL(url);
      return path.pathname;
    },
    removeWeirdCharacters(value) {
      if (value.includes('&#039;')) {
        value = value.replace(/&#039;/g, "'");
      }
      if (value.includes('&amp;')) {
        value = value.replace(/&amp;/g, '&');
      }
      return value;
    },
    getPlayingNow() {
      this.loading = true;
      axios
        .get(`${this.liveChannel.baseURL}/api/live-info-v2`)
        .then(response => {
          this.currentShow = response.data.shows.current;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_schedule-current-show.scss';
</style>
